<template>
  <div id="content-container">
    <div>
      <div class="panel" v-if="!productTemplateId">
        <div class="filter">
          <el-form
            :inline="true"
            :model="filter"
            ref="filterForm"
            label-position="right"
            label-width="90px"
            class="search-form"
            size="small"
          >
            <template v-if="filter.tab == 'second'">
              <el-form-item label="编码">
                <el-input
                  v-model="filter.code"
                  placeholder="搜索编码"
                ></el-input>
              </el-form-item>
              <el-form-item label="关键字">
                <el-input
                  v-model="filter.query"
                  placeholder="搜索自定义属性值"
                ></el-input>
              </el-form-item>
              <el-form-item label="库存基地">
                <BaseSelect
                  v-model="filter.base_id"
                  :clearable="true"
                  :filterBlank="true"
                ></BaseSelect>
              </el-form-item>
              <el-form-item label="钻井">
                <DrillWellSelect
                  v-model="filter.drill_well_id"
                  :clearable="true"
                ></DrillWellSelect>
              </el-form-item>
              <el-form-item label="有无库存">
                <el-select size="small" v-model="filter.stock_number_type">
                  <el-option label="不限" :value="0" key="0"></el-option>
                  <el-option label="有" :value="1" key="1"></el-option>
                  <el-option label="无" :value="2" key="2"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item label="发出基地">
                <BaseSelect
                  v-model="filter.from_base_id"
                  :clearable="true"
                ></BaseSelect>
              </el-form-item>
              <el-form-item label="发出钻井">
                <DrillWellSelect
                  v-model="filter.from_well_id"
                  :clearable="true"
                ></DrillWellSelect>
              </el-form-item>
              <el-form-item label="接收基地">
                <BaseSelect
                  v-model="filter.to_base_id"
                  :clearable="true"
                  :filterBlank="true"
                ></BaseSelect>
              </el-form-item>
              <el-form-item label="接收钻井">
                <DrillWellSelect
                  v-model="filter.to_well_id"
                  :clearable="true"
                ></DrillWellSelect>
              </el-form-item>
              <el-form-item label="状态">
                <el-select v-model="filter.status">
                  <el-option :key="0" :value="0" label="全部"></el-option>
                  <el-option :key="1" :value="1" label="待接收"></el-option>
                  <el-option :key="2" :value="2" label="已接收"></el-option>
                  <el-option :key="3" :value="3" label="已撤回"></el-option>
                  <el-option :key="4" :value="4" label="已拒收"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发出时间" prop="date">
                <el-date-picker
                  v-model="filter.send_date"
                  unlink-panels
                  type="daterange"
                  size="small"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="接收时间" prop="date">
                <el-date-picker
                  v-model="filter.receive_date"
                  unlink-panels
                  type="daterange"
                  size="small"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </template>
          </el-form>
          <div style="margin-left: 90px">
            <el-button type="primary" size="small" @click="productQuery()"
              >筛选</el-button
            >
            <el-button size="small" @click="productQuery(true)">重置</el-button>
          </div>
        </div>
      </div>

      <div class="panel temp-filter" v-if="!productTemplateId">
        <div class="group-container" v-if="groups.length > 1">
          <span
            class="mr-10 mb-10 pointer"
            :key="group.id"
            :class="{ active: group.id == activeTab }"
            @click="handleGroupClick(group.id)"
            v-for="group in groups"
            >{{ group.name }}
          </span>
        </div>
        <div v-if="groups.length == 0">暂无数据</div>
        <div
          class="group-container"
          style="padding-bottom: 10px"
          :value="selectedTemp.id"
          v-if="selectedTemp"
        >
          <draggable
            class="temp-list"
            :list="groupTemplates"
            ghost-class="ghost"
            @update="itemDragUpdate"
            :disabled="user.id != 1 && user.id != 27"
          >
            <el-tag
              size="small"
              class="pointer"
              :key="temp.id"
              :effect="temp.id == selectedTemp.id ? 'light' : 'plain'"
              :type="temp.id == selectedTemp.id ? 'primary' : 'info'"
              @click="handleTemplateChange(temp.id)"
              v-for="temp in groupTemplates"
              >{{ temp.name
              }}<span class="cus-badge" v-if="temp.stocking_count">{{
                temp.stocking_count
              }}</span>
            </el-tag>
          </draggable>
        </div>
        <div class="group-container" v-if="childrenGroups.length > 0">
          <span
            @click="handleChildrenGroupClick(item)"
            class="mr-10 mb-10 pointer"
            :class="{ active: filter.group_name == item }"
            v-for="item in childrenGroups"
            :key="item"
            >{{ item || '不限' }}</span
          >
        </div>
      </div>

      <div
        :class="{ panel: !productTemplateId }"
        v-if="templates && templates.length > 0"
      >
        <el-tabs v-model="filter.tab" @tab-click="handleTabClick">
          <el-tab-pane label="入库" name="first"></el-tab-pane>
          <el-tab-pane label="库存" name="second"></el-tab-pane>
        </el-tabs>
        <template v-if="selectedTemp">
          <ItemTable
            :template="selectedTemp"
            v-if="filter.tab == 'first'"
            :filter="filter"
            ref="itemTable"
            @baseCheck="handleBaseCheck"
          ></ItemTable>
          <NodeCodeTable
            :template="selectedTemp"
            v-if="filter.tab == 'second'"
            :filter="filter"
            ref="itemTable"
            @baseCheck="handleBaseCheck"
          ></NodeCodeTable>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { productTemplateList, productTemplateSort } from '@/service/getData'
import ItemTable from './group_table'
import NodeCodeTable from './NodeCodeTable.vue'
import draggable from 'vuedraggable'
import store from '@/store/index'

export default {
  props: {
    category: {
      type: Number,
      default: 2,
    },
    productTemplateId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ItemTable,
    NodeCodeTable,
    draggable,
  },
  data() {
    return {
      selectedTemp: null,
      templates: null,
      filter: {
        category: this.category,
        send_date: '',
        receive_date: '',
        group_name: '',
        code: '',
        query: '',
        base_id: 0,
        drill_well_id: 0,
        from_base_id: 0,
        from_well_id: 0,
        to_base_id: 0,
        to_well_id: 0,
        status: 0,
        product_template_id: 0,
        stock_type: 100,
        stock_number_type: 1,
        page: 1,
        size: 10,
        tab: 'first',
      },
      user: store.state.userInfo,
      groups: [],
      activeName: 'first',
    }
  },
  computed: {
    activeTab() {
      if (!this.selectedTemp) return ''
      return this.selectedTemp.template_group_id
    },
    groupTemplates() {
      if (!this.templates) return []
      return this.templates
        .filter((item) => item.template_group_id == this.activeTab)
        .sort(function (a, b) {
          return a.sort - b.sort
        })
    },
    childrenGroups() {
      if (this.selectedTemp && this.selectedTemp.children_groups) {
        return [''].concat(this.selectedTemp.children_groups.split('、'))
      } else {
        return []
      }
    },
  },
  created() {
    if (this.$route.query.filter) {
      let filter = JSON.parse(this.$route.query.filter)
      if (!filter.hasOwnProperty('group_name')) {
        filter.group_name = ''
      }
      this.filter = Object.assign(this.filter, filter)
    }

    if (this.$route.query.product_template_id) {
      this.filter.product_template_id = parseInt(
        this.$route.query.product_template_id,
      )
    }

    if (this.$route.query.hour_step) {
      this.filter.hour_step = this.$route.query.hour_step
    }

    this.getData()
  },
  methods: {
    handleTabClick(e) {
      this.$nextTick(() => {
        this.productQuery(true)
      })
    },
    handleBaseCheck() {
      if (this.productTemplateId == 0 && this.category == 2) {
        let currentTemp = this.templates.find(
          (temp) => temp.id === this.selectedTemp.id,
        )
        let index = this.templates.indexOf(currentTemp)
        this.templates[index].stocking_count--
      }
    },
    handleGroupClick(e) {
      this.filter.group_name = ''
      const temp = this.templates.filter((i) => i.template_group_id == e)[0]
      this.getProductData(temp, 1)
    },
    handleTemplateChange(id) {
      this.filter.group_name = ''
      this.getProductData(
        this.groupTemplates.find((i) => i.id == id),
        1,
      )
    },
    handleChildrenGroupClick(item) {
      this.filter.group_name = item
      this.productQuery()
    },
    async getData() {
      let res = await productTemplateList({
        page: 0,
        size: 1000,
        category: this.category,
        id: this.productTemplateId,
        order_sort: true,
        code_type: 2,
        stocking_count: this.productTemplateId == 0 && this.category == 2,
      })
      this.templates = res.data.list

      let groups = []
      this.templates.map((temp) => {
        if (!groups.find((item) => item.id == temp.template_group_id)) {
          groups.push({
            id: temp.group.id,
            name: temp.group.name,
            sort: temp.group.sort,
          })
        }
      })

      groups.sort(function (a, b) {
        if (a.sort == b.sort) {
          return a.id - b.id
        } else {
          return a.sort - b.sort
        }
      })

      this.groups = groups

      if (this.templates.length > 0) {
        let selectedTemp =
          this.templates.filter(
            (item) => item.id == this.filter.product_template_id,
          )[0] ||
          this.templates.filter(
            (item) => item.template_group_id == this.groups[0].id,
          )[0]
        this.getProductData(selectedTemp, this.filter.page || 1)
      }
    },
    getProductData(temp, page = 1) {
      this.selectedTemp = temp
      this.filter.product_template_id = temp.id
      this.filter.page = page

      let _this = this
      this.$nextTick(() => {
        _this.$refs.itemTable.getData()
      })
    },
    productQuery(reset = false, templateId = 0) {
      if (reset) {
        this.filter.code = ''
        this.filter.query = ''
        this.filter.base_id = 0
        this.filter.drill_well_id = 0
        this.filter.send_date = ''
        this.filter.receive_date = ''
        this.filter.from_base_id = 0
        this.filter.to_base_id = 0
        this.filter.from_well_id = 0
        this.filter.to_well_id = 0
        this.filter.status = 0
        this.filter.stock_type = this.filter.tab == 'first' ? 100 : 0
        this.filter.stock_number_type = 1
      }

      if (templateId) {
        //筛选某个分类的预警
        this.selectedTemp = this.templates.find((item) => item.id == templateId)
        this.filter.product_template_id = templateId
        this.filter.lifewarning = 1
      }

      this.filter.page = 1
      if (this.filter.receive_base_id) {
        this.filter.stock_status = 1
      }
      this.$refs.itemTable.getData()
    },
    async itemDragUpdate() {
      var ids = this.groupTemplates.map((item, index) => {
        item.sort = index + 1
        return item.id
      })
      let res = await productTemplateSort({
        ids: ids,
      })
    },
  },
}
</script>

<style scoped>
.pointer {
  position: relative;
}
.cus-badge {
  position: absolute;
  right: -4px;
  top: -6px;
  background-color: rgb(245, 108, 108);
  color: rgb(255, 255, 255);
  display: inline-block;
  font-size: 10px;
  height: 15px;
  line-height: 12px;
  text-align: center;
  border-radius: 8px;
  padding: 0px 4px;
  white-space: nowrap;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(255, 255, 255);
  border-image: initial;
}

.temp-filter {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.temp-filter .active {
  color: #409eff;
}

.group-container {
  padding-bottom: 5px;
  border-bottom: 1px dashed #eee;
}

.group-container:last-child {
  border-bottom: none;
  padding-bottom: 0 !important;
}

.temp-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
</style>